import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import api from '../api';
import { Provider as name } from '../config';

import Context from './context';

const SettingsProvider = (props) => {
    const { children } = props;
    const [data, setData] = useState([]);
    const [schema, setSchema] = useState({});
    const [selected, setSelected] = useState({});
    const [error, setError] = useState({});

    const getById = useCallback(
        (id) =>
            api
                .getById(id)
                .then((res) => {
                    setSelected(res);
                    return res;
                })
                .catch(setError),
        []
    );
    const get = useCallback(
        (params) =>
            api
                .get(params)
                .then((res) => {
                    setData(res);
                    setSelected(res[0]);
                    return res;
                })
                .catch(setError),
        []
    );

    const getSchema = useCallback(() => {
        if (!Object.keys(schema).length) {
            return api
                .getSchema()
                .then((res) => {
                    console.log('res', res); // eslint-disable-line
                    // const src = Object.keys(res).reduce((acc, next) => {
                    //     // eslint-disable-line
                    //     // console.log('next', next);
                    //     return acc;
                    // }, res);
                    setSchema(res);
                    return res;
                })
                .catch(setError);
            // eslint-disable-next-line
        } else {
            return schema;
        }
    }, [schema]);

    const post = useCallback(
        (body) =>
            api
                .post(body)
                .then((res) => {
                    setData(data.concat(res));
                    return res;
                })
                .catch(setError),
        [data]
    );

    const put = useCallback(
        // eslint-disable-next-line
        (body) => {
            return (
                api
                    .put(body)
                    // eslint-disable-next-line
                    .then((response) => {
                        return getById(response._id).then((res) => {
                            const items = data.reduce((acc, next) => {
                                if (res._id === next._id) {
                                    return acc.concat(res);
                                }
                                return acc.concat(next);
                            }, []);
                            setData(items);
                            return response;
                        });
                    })
                    .catch(setError)
            );
        },
        [data, getById]
    );

    const remove = useCallback(
        // eslint-disable-next-line
        (id) => {
            return api
                .remove(id)
                .then((deletedID) => {
                    const filter = data.filter((item) => item._id !== deletedID);
                    setData(filter);
                    setSelected({});
                    return deletedID;
                })
                .catch(setError);
        },
        [data]
    );
    return (
        <Context.Provider
            value={{
                name,
                get,
                getById,
                getSchema,
                schema,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove,
                error
            }}
        >
            {children}
        </Context.Provider>
    );
};

SettingsProvider.propTypes = {
    children: PropTypes.element.isRequired
};

export default SettingsProvider;
